import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import pluralize from 'pluralize';

import { getAsset } from '../../../../../util/assets';

const REDIRECT_DELAY_SECONDS = 5;

const propTypes = {
  loginPath: PropTypes.string.isRequired,
  message: PropTypes.node,
  imageAlt: PropTypes.string,
};

const InvitationAcceptSuccessStep = ({
  loginPath,
  message = (
    <>
      Your invitation has been{' '}
      <span className="text-primary text-bold">accepted!</span>
    </>
  ),
}) => {
  const history = useHistory();
  const [currentCountdownValue, setCurrentCountdownValue] = useState(
    REDIRECT_DELAY_SECONDS,
  );

  useEffect(() => {
    if (currentCountdownValue <= 0) {
      history.push(loginPath);
      return undefined;
    }
    const timeoutId = setTimeout(() => {
      setCurrentCountdownValue(value => value - 1);
    }, 1000);
    return () => clearTimeout(timeoutId);
  }, [currentCountdownValue, history, loginPath]);

  return (
    <div className="team-member-invitation-success-content-container">
      <img
        src={getAsset('/waldo-excited.png')}
        alt="waldo-excited"
        style={{ height: '80px' }}
        className="mb-4"
      />
      <p className="mb-0">
        {message} You will be redirected to the log in page in{' '}
        <span className="text-bold">{currentCountdownValue}</span>{' '}
        {pluralize('second', currentCountdownValue)}
      </p>
    </div>
  );
};

InvitationAcceptSuccessStep.propTypes = propTypes;

export default InvitationAcceptSuccessStep;
